<template>
  <div id="login-container" :class="webnamefinal">
    <Navigationbar v-if="!isInIframe" :webname="webnamefinal"> </Navigationbar>
    <b-loading
      v-if="isLoading"
      :is-full-page="true"
      :active="isLoading"
    ></b-loading>

    <div id="content-frame" v-else>
      <div id="content-inner">
        <div id="content-logo">
          <img :src="logourl" class="top-logo" />
        </div>
        <div id="content-main">
          <Login v-bind="$props"> </Login>
        </div>
      </div>
    </div>

    <Footerbar v-if="!isInIframe && isLoading == false"> </Footerbar>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import Navigationbar from '@/components/UI/Navigationbar.vue'
import Footerbar from '@/components/UI/Footerbar.vue'
import { topLevelPageMixin } from '@/components/mixins/topLevelPageMixin'
import { ToolsMixin } from '@/components/mixins/ToolsMixin'

export default {
  name: 'LoginWindow',
  components: {
    Login,
    Navigationbar,
    Footerbar
  },
  mixins: [topLevelPageMixin, ToolsMixin],
  props: {
    webname: {
      type: String,
      default: ''
    },
    env: {
      type: String,
      default: 'PRO'
    }
  },
  data() {
    return {
      inputs: {
        email: '',
        password: ''
      },
      isLoading: true,
      webnamefinal: ''
    }
  },
  computed: {
    logourl: function() {
      return process.env.BASE_URL + this.webnamefinal + '/logo.png'
    },
    texts: function() {
      return this.$store.state.decoupled.configFile.texts
    },
    isInIframe: function() {
      return window.location != window.parent.location ? true : false
    }
  },
  methods: {
    close: function() {
      this.$parent.close()
      //  this.$store.commit('showHideSettings', false)
    },
    saveAndClose: function() {
      /* this.$store.commit('setProjectTitle', this.title)
      this.$store.commit('setProjectDescription', this.description)
      this.hideSetings()
      this.$emit('save') */
    },
    showRegister: function() {
      this.$emit('register')
    }
    /*setGlobalVariables(){
      apiurl.proxy='https://'+this.slaveurl+'/'
      console.log(apiurl)
    }*/
  },
  beforeMount() {
    //do something before mounting vue instance
  },
  created() {
    this.retrieveConfigFilesAndInit()
  }
}
</script>

<style lang="less">
@import (reference) '../assets/styles/common.less';

#login-container {
  -webkit-overflow-scrolling: touch;
}

#content-frame {
  margin: auto;
  margin-top: 42px;
  margin-bottom: 42px;
  width: 500px;
  min-height: calc(100vh - 42px * 3.5);
  position: inherit;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  background-color: #fff;
}

#content-inner {
  max-width: 360px;
  padding: 16px;
  margin: auto;
  margin-top: 0px;
  margin-bottom: 0px;
}

#content-frame,
#content-inner,
#content-main {
  display: flex;
  flex-direction: column;
  flex: 1;
}

h2 {
  margin-bottom: 2em;
}

#content-logo {
  padding-top: 20px;
  text-align: center;
  padding-bottom: 20px;
}

@media (max-width: @mobilebreakpoint) {
  .top-part-notmobile {
    display: none;
  }
  div#login-container {
    background-color: #fff !important;
  }
  #content-frame {
    border-radius: 0px;
    padding-top: 0px;
    border: none;
    box-shadow: none;
    max-height: none;
    width: auto;
    height: auto;
  }
  #register-container {
    background: #fff;
  }
  .register-header {
    margin-left: -20px;
  }
}
</style>
